import React, { useContext, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH, faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { ActionButtonContext } from './ActionButtonContext'

export default function DropdownActionButton({ id, list, vertical = false }) {
  const ref = useRef(null)
  const { activeDropdown, setActiveDropdown } = useContext(ActionButtonContext)
  const isOpen = activeDropdown === id

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      if (isOpen) setActiveDropdown(null)
    }
  }

  const handleDropdown = (e) => {
    e.stopPropagation()
    setActiveDropdown(isOpen ? null : id)
  }

  const handleAction = (handler) => {
    handler()
    setActiveDropdown(null)
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [isOpen])

  return (
    <div ref={ref} className="dropdown-btn-container">
      <button className="dropdown-btn" type="button" onClick={(e) => handleDropdown(e)}>
        <FontAwesomeIcon icon={vertical ? faEllipsisV : faEllipsisH} style={{ margin: 0 }} />
      </button>
      <div className={`dropdown-btn-ul ${isOpen ? 'active' : ''}`}>
        {list.map(
          (item, index) =>
            !item.disabled && (
              <div
                key={index}
                className="dropdown-btn-li"
                onClick={(e) => {
                  e.stopPropagation()
                  item.handler
                    ? handleAction(item.handler)
                    : console.log(item.text + ' button executed (missing handler)')
                }}
              >
                {item.text}
              </div>
            )
        )}
      </div>
    </div>
  )
}
